import { SakaiSitePicker } from './src/SakaiSitePicker.js';

!customElements.get("sakai-site-picker") && customElements.define('sakai-site-picker', SakaiSitePicker);
